<template>
  <div>
    <div class="advanceParent">
      <span style="display: block;padding:20px;float: right">{{
        item.title
      }}</span>
      <export-excel
        :data="report"
        :fields="excelHeaders"
        worksheet="My Worksheet"
        :name="`${item.title}.xls`"
      >
        <app-history class="advancedSearch" title="خروجی اکسل" />
      </export-excel>
    </div>
    <div>
      <v-data-table
        :items="report"
        :headers="reportHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
      >
        <template v-slot:[`item.amount`]="{ item }">
          {{ Number(item.amount).toLocaleString() }}
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetAdminPardakhtDetail } from "@/api/payments";
import moment from "moment-jalaali";
export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showDialog: false,
      report: [],

      StartDate: "",
      EndDate: "",
      reportHeaders: [
        {
          text: "کد مدرسه",
          value: "schoolCode",
        },
        {
          text: "نام مدرسه",
          value: "schoolName",
        },
        {
          text: "بانک",
          value: "bankName",
        },
        {
          text: "شماره حساب",
          value: "acountNumber",
        },
        {
          text: "شبا",
          value: "sheba",
        },

        {
          text: "مبلغ (ریال)",
          value: "amount",
        },
      ],
      excelHeaders: {
        "کد مدرسه": "schoolCode",
        "نام مدرسه": "schoolName",
        "بانک": "bankName",
        "شماره حساب": "acountNumber",
        شبا: "sheba",

        "مبلغ": {
          field: "amount",
          callback: (value) => {
            return Number(value).toLocaleString();
          },
        },
      },
    };
  },
  props: ["item"],
  created() {
    this.GetAdminPardakhtDetail();
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },

  methods: {
    GetAdminPardakhtDetail() {
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetAdminPardakhtDetail(this.item.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.report = response.data.items;
            this.totalCount = response.data.count;
            this.$store.commit("SET_TABLE_TEXT", false);
            this.showDialog = false;

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    convertDate(date) {
      return moment(date).format("HH:mm jYYYY/jMM/jDD");
    },
  },
};
</script>
<style>
.text-start.cellLtr {
  direction: ltr;
  text-align: end !important;
}

.textLtr input {
  direction: ltr;
  text-align: right;
}

.filterButton {
  width: 100%;
}
</style>
